import { Block } from "./shared/Block";
import { BlockSection } from "./shared/BlockSection";
import { useTranslation } from "react-i18next";
import { Slider } from "@/components/ui/slider";
import { Separator } from "@/components/ui/separator";
import { ColorPicker } from "./shared/ColorPicker";
// import { TransformOptions } from "./shared/TransformOptions";
import { Delete } from "./shared/Delete";
import { LayerOption } from "./shared/LayerOption";
import { ChangeLayerFunction } from "@/components/canvas/extensions/layerManagerExtension";
import { Button } from "@/components/ui/button";
import { ImageIcon } from "lucide-react";

type ImageInspectorProps = {
  opacityOption: {
    value: number;
    onChange: (value: number) => void;
  };
  strokeColorOption: {
    value: string;
    onChange: (value: string) => void;
  };
  strokeWidthOption: {
    value: number;
    onChange: (value: number) => void;
  };
  xPositionOption: {
    value: number;
    onChange: (value: number) => void;
  };
  yPositionOption: {
    value: number;
    onChange: (value: number) => void;
  };
  widthOption: {
    value: number;
    onChange: (value: number) => void;
  };
  heightOption: {
    value: number;
    onChange: (value: number) => void;
  };
  rotationOption: {
    value: number;
    onChange: (value: number) => void;
  };
  onLayerChange: ChangeLayerFunction;
  onDeleteElementClick: () => void;
  // Not enabled yet, might be needed in the future
  onSetAsBackgroundImageClick: () => void;
};

export const ImageInspectorContent: React.FC<ImageInspectorProps> = ({
  opacityOption,
  strokeColorOption,
  strokeWidthOption,
  // xPositionOption,
  // yPositionOption,
  // widthOption,
  // heightOption,
  // rotationOption,
  onLayerChange,
  onDeleteElementClick,
  onSetAsBackgroundImageClick,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      {/* Fill */}
      <Block title={t("template.inspector.fill")}>
        <BlockSection title={t("template.inspector.opacity")}>
          <Slider
            value={[opacityOption.value]}
            onValueChange={(value) => opacityOption.onChange(value[0])}
            step={0.1}
            max={1}
          />
        </BlockSection>
      </Block>
      <Separator />
      {/* Stroke */}
      <Block title={t("template.inspector.stroke")}>
        <BlockSection title={t("template.inspector.color")}>
          <ColorPicker color={strokeColorOption.value} onChange={strokeColorOption.onChange} />
        </BlockSection>
        <BlockSection title={t("template.inspector.width")}>
          <Slider
            value={[strokeWidthOption.value]}
            onValueChange={(value) => strokeWidthOption.onChange(value[0])}
            step={1}
            max={100}
          />
        </BlockSection>
      </Block>
      <Separator />
      <LayerOption handleLayerChange={onLayerChange} />
      <Separator />
      <Block title={t("template.inspector.setAsBackgroundImage")}>
        <Button onClick={onSetAsBackgroundImageClick} variant="outline">
          <ImageIcon />
          <span className="ml-2">{t("template.inspector.set")}</span>
        </Button>
      </Block>
      {/* Transform */}
      {/* <TransformOptions
        rotationOption={rotationOption}
        widthOption={widthOption}
        heightOption={heightOption}
        yPositionOption={yPositionOption}
        xPositionOption={xPositionOption}
      /> */}
      <Separator />
      {/* Delete */}
      <Delete onClick={onDeleteElementClick} />
    </div>
  );
};
